import { GET_TEXTOS, GET_TEXTOS_FAIL, GET_TEXTOS_SUCCESS } from "../ActionTypes";
import axiosLogin from "global/helpers/axiosLogin";

export const wsGetTextosCheckIn = () => (dispatch) => {
    dispatch({type: GET_TEXTOS}); 

    axiosLogin().then(respuesta => {
        respuesta 
        .get('shared/textos/autocheckin')
        .then(resp => dispatch({type: GET_TEXTOS_SUCCESS, payload: resp.data}))
        .catch(err => dispatch({type: GET_TEXTOS_FAIL, payload: err}))
    })
}


